import { useState, useEffect, useCallback } from 'react'
import { getBalanceAmount } from '../../../api/public/wallet'
import { getUser } from '../../../services/auth'

export default function useGetBalance() {
    const [balance, setBalance] = useState("...")

    const fetchBalance = useCallback(async () => {
        let user = getUser()
        let data = await getBalanceAmount(user.userId, user.token)
        if (data & data?.error) {
            setBalance("error")
        }
        else {
            if (data?.netAmount === undefined) {
                setBalance("0.00")
            } else {
                setBalance(data.netAmount)
            }
        }
    }, [])

    useEffect(() => {
        let mounted = true

        if (mounted) {
           fetchBalance()
        }

        return () => {
            mounted = false
        }
    }, [])


    return balance
}